// extracted by mini-css-extract-plugin
module.exports = {"ascii":"ASCII_ascii__ySvgc","move":"ASCII_move__33dS_","orbit":"ASCII_orbit__2ebmk","orbitReverse":"ASCII_orbitReverse__2Xe_t","wiggle":"ASCII_wiggle__2IUWO"};